// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: "Inter", sans-serif;
    background-color: #181A20;
    overflow-x: hidden;
    max-width: 100%;
    position: relative;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    text-rendering: geometricPrecision;
    font-weight: 400;
}

body.contact {
    background-color: #111114 !important;
}

@supports (overflow: clip) {
    body {
        overflow-x: clip;
        overflow-y: auto;
    }
}

body {
    background-color: #000;
}

html {
    scroll-behavior: auto !important;
    overflow-x: hidden;
    max-width: 100%;
    overscroll-behavior-x: none;
}

@supports (overflow: clip) {
    html {
        overflow-x: clip;
        overflow-y: auto;
    }
}

#root {
    overflow-x: hidden;
    max-width: 100%;
}

@supports (overflow: clip) {
    #root {
        overflow-x: clip;
        overflow-y: visible;
    }
}

#root:has(header.sticky-top) {
    padding-top: 58px;
}

html:has(header.sticky-top) {
    scroll-padding-top: 58px;
}

h1 {
    font-family: "Inter", sans-serif;
    font-size: 3.2rem;
}

h2 {
    font-family: "Inter", sans-serif;
}

.h2,
h2 {
    font-size: 3.2rem;
}

a {
    text-decoration: none;
    transition: 0.5s all;
}

img {
    max-width: 100%;
}

ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
}

p {
    font-size: 18px;
    line-height: 140%;
    font-weight: 300;
}


/* ========== CONTAINER OVERRIDE (style.css) ========== */

.container,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
    max-width: 1380px;
    padding: 0px 20px;
}


/* ========== PAGE BANNER / SECTION (style.css) ========== */

.section-padding.feature_bg.pc_bg {
    display: flex;
    flex-direction: column;
    color: #fffffff0;
    gap: 0px;
    justify-content: space-between;
    background-color: #111114;
    padding: 80px 0px;
    /* background-image: url(../images/buler_bg.png); */
    background-position-y: top;
    background-position-x: right;
    background-size: contain;
    background-repeat: no-repeat;
}

.section-padding.feature_bg.pc_bg .row.align-items-center.py-5 {
    padding-top: 0px !important;
}

.section-padding.feature_bg.pc_bg p {
    font-size: 18px;
}

.section-padding.feature_bg.pc_bg h3 {
    font-size: 24px;
    margin-bottom: 15px;
}


/* ========== BREADCRUMB (style.css) ========== */

.breadcrumb li {
    color: #fff !important;
}

.breadcrumb li a {
    color: #D1AA67 !important;
}


/* ========== CONTENT WRAPPER (style.css) ========== */

.create-item-wrapper a {
    color: #D1AA67;
}


/* ========== LIGHT THEME (light_theme.css) ========== */

body.light_theme {
    background-color: #fff !important;
}

body.light_theme .section-padding.feature_bg.pc_bg {
    color: #333333f0;
    background-color: #ffffff;
}

body.light_theme .breadcrumb li {
    color: #343434 !important;
}


/* ========== RESPONSIVE (style.css) ========== */

@media screen and (max-width:1700px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 90%;
    }
}

@media screen and (max-width:1440px) {
    h1 {
        font-size: 2.8rem;
    }

    #root:has(header.sticky-top) {
        padding-top: 40px;
    }

    html:has(header.sticky-top) {
        scroll-padding-top: 40px;
    }
}

@media screen and (max-width:1367px) {
    h1 {
        font-size: 2.5rem;
    }

    h1 {
        font-size: 2.2rem;
    }
}

@media screen and (max-width:1200px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 95%;
    }

    .section-padding.feature_bg.pc_bg p {
        font-size: 15px;
    }

    .section-padding.feature_bg.pc_bg {
        padding: 50px 0px 20px;
    }

    p {
        font-size: 16px;
    }
}

@media screen and (max-width:991px) {
    p {
        font-size: 14px;
    }
}

@media screen and (max-width:767px) {
    #root:has(header.sticky-top) {
        padding-top: 40px;
    }

    html:has(header.sticky-top) {
        padding-top: 0px;
    }

    h1 {
        font-size: 1.7rem;
    }

    p {
        font-size: 14px;
    }

    .plicy_sec {
        font-size: 13px;
    }

    .plicy_sec br {
        display: none;
    }

    .section-padding.feature_bg.pc_bg {
        padding: 24px 0px;
    }

    body .section-padding.feature_bg.pc_bg .pt-5 {
        padding: 15px 0px 20px !important;
    }

    .create-item-wrapper.plicy_sec .col-lg-6 {
        margin-top: 0px;
    }

    .section-padding.feature_bg.pc_bg h3 {
        font-size: 18px;
    }

    .section-padding.feature_bg.pc_bg .pt-5 {
        padding-top: 2rem !important;
    }

    .section-padding.feature_bg.pc_bg {
        padding: 30px 0px;
    }

    .section-padding.feature_bg.pc_bg.login_sec .row.align-items-center.py-4 {
        padding: 0px !important;
    }

    section.section-padding.feature_bg.pc_bg.login_sec {
        padding-bottom: 0px;
    }

    .section-padding.feature_bg.pc_bg p {
        font-size: 14px;
    }

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl,
    .container-xxl {
        max-width: 98%;
    }
}

@media screen and (max-width:480px) {
    p {
        font-size: 12px;
    }
}

@media screen and (max-width:414px) {
    .section-padding.feature_bg.pc_bg p {
        font-size: 12px;
    }

    .plicy_sec {
        font-size: 12px;
    }

    p {
        font-size: 12px;
    }
}


/* =========================================================
   UNDEFINED IN CRA CSS (used in markup, no rules found):
   - .cc_row
   - .cc_col
   - .career_sec
   - .pb-90
   - .title  (standalone; only scoped variants exist elsewhere)
   - .inner  (only under section.inner-page-banner.bg-2)
   - .login_sec alone (only with .login_bg.market_page or
     .section-padding.feature_bg.pc_bg.login_sec combos)
   Do NOT invent styles for these.
   ========================================================= */`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Contactus/contact.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA,yDAAyD;;AAEzD;;;;;;IAMI,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA,4DAA4D;;AAE5D;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;IACjB,mDAAmD;IACnD,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;;AAGA,iDAAiD;;AAEjD;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,sDAAsD;;AAEtD;IACI,cAAc;AAClB;;;AAGA,wDAAwD;;AAExD;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,iDAAiD;;AAEjD;;IAEI;;;;;;QAMI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;;;;;;QAMI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;;;;QAMI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;;;;;;;;;;;8DAW8D","sourcesContent":["body {\n    font-family: \"Inter\", sans-serif;\n    background-color: #181A20;\n    overflow-x: hidden;\n    max-width: 100%;\n    position: relative;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    text-rendering: geometricPrecision;\n    font-weight: 400;\n}\n\nbody.contact {\n    background-color: #111114 !important;\n}\n\n@supports (overflow: clip) {\n    body {\n        overflow-x: clip;\n        overflow-y: auto;\n    }\n}\n\nbody {\n    background-color: #000;\n}\n\nhtml {\n    scroll-behavior: auto !important;\n    overflow-x: hidden;\n    max-width: 100%;\n    overscroll-behavior-x: none;\n}\n\n@supports (overflow: clip) {\n    html {\n        overflow-x: clip;\n        overflow-y: auto;\n    }\n}\n\n#root {\n    overflow-x: hidden;\n    max-width: 100%;\n}\n\n@supports (overflow: clip) {\n    #root {\n        overflow-x: clip;\n        overflow-y: visible;\n    }\n}\n\n#root:has(header.sticky-top) {\n    padding-top: 58px;\n}\n\nhtml:has(header.sticky-top) {\n    scroll-padding-top: 58px;\n}\n\nh1 {\n    font-family: \"Inter\", sans-serif;\n    font-size: 3.2rem;\n}\n\nh2 {\n    font-family: \"Inter\", sans-serif;\n}\n\n.h2,\nh2 {\n    font-size: 3.2rem;\n}\n\na {\n    text-decoration: none;\n    transition: 0.5s all;\n}\n\nimg {\n    max-width: 100%;\n}\n\nul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n}\n\np {\n    font-size: 18px;\n    line-height: 140%;\n    font-weight: 300;\n}\n\n\n/* ========== CONTAINER OVERRIDE (style.css) ========== */\n\n.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl {\n    max-width: 1380px;\n    padding: 0px 20px;\n}\n\n\n/* ========== PAGE BANNER / SECTION (style.css) ========== */\n\n.section-padding.feature_bg.pc_bg {\n    display: flex;\n    flex-direction: column;\n    color: #fffffff0;\n    gap: 0px;\n    justify-content: space-between;\n    background-color: #111114;\n    padding: 80px 0px;\n    /* background-image: url(../images/buler_bg.png); */\n    background-position-y: top;\n    background-position-x: right;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n.section-padding.feature_bg.pc_bg .row.align-items-center.py-5 {\n    padding-top: 0px !important;\n}\n\n.section-padding.feature_bg.pc_bg p {\n    font-size: 18px;\n}\n\n.section-padding.feature_bg.pc_bg h3 {\n    font-size: 24px;\n    margin-bottom: 15px;\n}\n\n\n/* ========== BREADCRUMB (style.css) ========== */\n\n.breadcrumb li {\n    color: #fff !important;\n}\n\n.breadcrumb li a {\n    color: #D1AA67 !important;\n}\n\n\n/* ========== CONTENT WRAPPER (style.css) ========== */\n\n.create-item-wrapper a {\n    color: #D1AA67;\n}\n\n\n/* ========== LIGHT THEME (light_theme.css) ========== */\n\nbody.light_theme {\n    background-color: #fff !important;\n}\n\nbody.light_theme .section-padding.feature_bg.pc_bg {\n    color: #333333f0;\n    background-color: #ffffff;\n}\n\nbody.light_theme .breadcrumb li {\n    color: #343434 !important;\n}\n\n\n/* ========== RESPONSIVE (style.css) ========== */\n\n@media screen and (max-width:1700px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 90%;\n    }\n}\n\n@media screen and (max-width:1440px) {\n    h1 {\n        font-size: 2.8rem;\n    }\n\n    #root:has(header.sticky-top) {\n        padding-top: 40px;\n    }\n\n    html:has(header.sticky-top) {\n        scroll-padding-top: 40px;\n    }\n}\n\n@media screen and (max-width:1367px) {\n    h1 {\n        font-size: 2.5rem;\n    }\n\n    h1 {\n        font-size: 2.2rem;\n    }\n}\n\n@media screen and (max-width:1200px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 95%;\n    }\n\n    .section-padding.feature_bg.pc_bg p {\n        font-size: 15px;\n    }\n\n    .section-padding.feature_bg.pc_bg {\n        padding: 50px 0px 20px;\n    }\n\n    p {\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width:991px) {\n    p {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width:767px) {\n    #root:has(header.sticky-top) {\n        padding-top: 40px;\n    }\n\n    html:has(header.sticky-top) {\n        padding-top: 0px;\n    }\n\n    h1 {\n        font-size: 1.7rem;\n    }\n\n    p {\n        font-size: 14px;\n    }\n\n    .plicy_sec {\n        font-size: 13px;\n    }\n\n    .plicy_sec br {\n        display: none;\n    }\n\n    .section-padding.feature_bg.pc_bg {\n        padding: 24px 0px;\n    }\n\n    body .section-padding.feature_bg.pc_bg .pt-5 {\n        padding: 15px 0px 20px !important;\n    }\n\n    .create-item-wrapper.plicy_sec .col-lg-6 {\n        margin-top: 0px;\n    }\n\n    .section-padding.feature_bg.pc_bg h3 {\n        font-size: 18px;\n    }\n\n    .section-padding.feature_bg.pc_bg .pt-5 {\n        padding-top: 2rem !important;\n    }\n\n    .section-padding.feature_bg.pc_bg {\n        padding: 30px 0px;\n    }\n\n    .section-padding.feature_bg.pc_bg.login_sec .row.align-items-center.py-4 {\n        padding: 0px !important;\n    }\n\n    section.section-padding.feature_bg.pc_bg.login_sec {\n        padding-bottom: 0px;\n    }\n\n    .section-padding.feature_bg.pc_bg p {\n        font-size: 14px;\n    }\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl,\n    .container-xxl {\n        max-width: 98%;\n    }\n}\n\n@media screen and (max-width:480px) {\n    p {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width:414px) {\n    .section-padding.feature_bg.pc_bg p {\n        font-size: 12px;\n    }\n\n    .plicy_sec {\n        font-size: 12px;\n    }\n\n    p {\n        font-size: 12px;\n    }\n}\n\n\n/* =========================================================\n   UNDEFINED IN CRA CSS (used in markup, no rules found):\n   - .cc_row\n   - .cc_col\n   - .career_sec\n   - .pb-90\n   - .title  (standalone; only scoped variants exist elsewhere)\n   - .inner  (only under section.inner-page-banner.bg-2)\n   - .login_sec alone (only with .login_bg.market_page or\n     .section-padding.feature_bg.pc_bg.login_sec combos)\n   Do NOT invent styles for these.\n   ========================================================= */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
